import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';
import {setter} from '@ibibo/client-side-storage';
import {sendEvarData} from '@ibibo/analytics';
import * as actions from '../../../store/actions/index';
import {
  getEmailOtpVerificationData,
  login,
  setAgentData,
  updateSid,
  getPanVerificationData,
  getTdsSlabData,
  getGccMobileVerificationData,
} from '../../../store/actions/thunk';
import {REGEX} from '../../../utils/validations';
import {nextLoader} from '../../../store/selectors';
import {mobileSelector} from '../../../store/selectors';
import {MOBILE_END_PAGE_URL, VERIFY_OTP_NEW_URL, VERIFY_PAGE_URL} from '../../../constants/index';
import LoginNew from '../../../stories/components/OnboardingNew/PopUp/LoginNew/LoginNew';
import ForgetPassword from '../../../stories/components/OnboardingNew/PopUp/ForgetPassword/ForgetPassword';
import {
  redirectToSameWindowWithoutRefresh,
  getUrlWithCrid,
  getCrid,
} from '../../../../../myaccount/src/utils/redirectWithCrId';
import {useAnalyticService} from '@ibibo/analytics-provider';
const LoginPop = ({
  loginPageFlag,
  setLoginPageFlag,
  setEmailActivationLinkInfoData,
  setPanVerificationData,
  setRedirectUrl,
  setVerificationScreen,
  setMobileVerificationData,
  setModalUpdateDetailsData,
  setVerificationData,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {sendTrackingDataToSdk} = useAnalyticService();
  const isLoading = useSelector(nextLoader);
  const userMobile = useSelector(mobileSelector);

  const [apiError, setApiError] = useState('');
  const [updatePwdApiError, setUpdatePwdApiError] = useState('');
  const [sendOTPResponse, setSendOTPResponse] = useState(null);
  const [otpVisible, setOtpVisible] = useState(false);
  const [apiDataObject, setApiDataObject] = useState({message: '', data: {account_exists: true}});
  const [forgotPasswordLoader, setForgotPasswordLoader] = useState(false);
  const [updatePwdSuccessMessage, setUpdatePwdSuccessMessage] = useState('');
  const [verifyEmailFlag, setVerifyEmailflag] = useState(false);
  const [loginFlag, setLoginFlag] = useState(true);
  const [newEmail, setNewEmail] = useState('');
  const [showNewEmailInput, setShowNewEmailInput] = useState(false);
  const [emailOtpError, setEmailOtpErrpr] = useState('');
  let isEmailLoading = false; //to be changed later
  const [emailExist, setEmailExist] = useState(false);
  const [responseRedirectUrl, setResponseRedirectUrl] = useState('');
  const [popupToShow, setPopupToShow] = useState('');
  const [is2FARequired, setIs2FARequired] = useState(false);

  const deviceWidth = window.screen.width;

  useEffect(() => {
    if (!loginFlag) {
      setVerifyEmailflag(true);
    }
  }, [loginFlag]);

  useEffect(() => {
    fetchRequestForPopupType();
  }, [popupToShow]);

  let blockType = false;
  if (deviceWidth > 1024) {
    blockType = true;
  }

  const fetchRequestForPopupType = () => {
    if (popupToShow) {
      if (popupToShow === 'GSTN_PAN_Verification') {
        setVerificationScreen('GSTN_PAN_Verification');
        dispatch(
          getPanVerificationData(panVerificationSuccessCallback, panVerificationErrorCallback),
        );
      } else if (popupToShow === 'Email_Verification') {
        dispatch(
          getEmailOtpVerificationData(
            emailVerificationSuccessCallback,
            emailVerificationErrorCallback,
          ),
        );
      } else if (popupToShow === 'tdsSlabInformation') {
        setVerificationScreen(popupToShow);
        dispatch(getTdsSlabData(getTdsSlabDataSuccessCallback, getTdsSlabDataErrorCallback));
      } else if (popupToShow === 'Mobile_Verification') {
        setVerificationScreen(popupToShow);
        dispatch(
          getGccMobileVerificationData(
            gccMobileVerificationSuccessCallback,
            gccMobileVerificationErrorCallback,
          ),
        );
      } else {
        window.open(responseRedirectUrl, '_self');
      }
    }
  };

  const successCallback = (resp, sendOTPFn) => {
    if (resp.data.status && resp.data.token) {
      dispatch(setAgentData(resp.data.token, successSetAgentData, errorSetAgentData));
    }
    function successUpdateCallback(status) {
      if (resp.is2FARequired) {
        setIs2FARequired(resp.is2FARequired);
        //this case is required where we want to agent to land to OTP verification as well because of multi factor authentication support.
        sendOTPFn();

        sendEvarData(
          {
            prop54: 'myp_MFAShown',
          },
          true,
        );
        sendTrackingDataToSdk?.(
          {
            event_detail: {
              event_name: 'click',
              event_type: 'user_action',
              event_value: '2FAShown',
            },
          },
          'HOME',
        );
        return;
      }
      if (resp.mmt_auth) {
        setter('myPartnerAuth', {mmt_auth: resp.mmt_auth});
        setter('experiment', {experiment: resp.experiment});
      }
      if (resp.redirect_url) {
        //window.open(resp.redirect_url, '_self');
        setRedirectUrl(resp.redirect_url);
        setResponseRedirectUrl(resp.redirect_url);
      } else {
        // window.open('/hotels/', '_self');
        setResponseRedirectUrl('/hotels/');
      }
      if (resp?.popup_type) {
        setPopupToShow(resp.popup_type);
      } else {
        window.open(resp.redirect_url, '_self');
      }
    }
    dispatch(updateSid(resp, successUpdateCallback, false));
  };

  const successSetAgentData = () => {
    history.push(`${VERIFY_OTP_NEW_URL}?crId=${getCrid()}`);
  };

  const errorSetAgentData = () => {};

  const sendOTPSuccessCallback = resp => {
    setSendOTPResponse(resp);
    if (resp.data.status && resp.data.token) {
      dispatch(setAgentData(resp.data.token, successSetAgentData, errorSetAgentData));
    }
  };

  const errorCallback = error => {
    setApiError(error.message || 'Error! Please try after sometime.');
    setSendOTPResponse(error);
    // to handle the case where we want to update the pwd(MMT account exists or not)
    setApiDataObject(error);
  };

  const emailVerify = () => {};

  let userUrl = window.location.search;
  let newUrl = userUrl.substring(1);
  let docRef = document.referrer;

  const submitDetails = (data, sendOTPFn) => {
    let fd = new FormData();
    if (deviceWidth < 1024) {
      fd.append('dt', 'false');
    } else {
      fd.append('dt', 'true');
    }
    fd.append('username', data.username);
    if (sendOTPResponse && sendOTPResponse.data && sendOTPResponse.data.token) {
      fd.append('token', sendOTPResponse.data.token);
    }
    if (data.password) {
      fd.append('password', data.password);
    }
    if (data.mobile_otp) {
      fd.append('mobile_otp', data.mobile_otp);
    }
    if (apiDataObject.data?.account_exists && apiDataObject.data?.token) {
      fd.append('token', apiDataObject.data?.token);
    }
    clearUpdatePasswordMessages();
    // setUpdatePwdSuccessMessage('');
    // setUpdatePwdApiError('');
    fd.append('referrer', userUrl === '' ? docRef : newUrl);
    dispatch(login(fd, successCallback, errorCallback, sendOTPFn));
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: data.mobile_otp ? 'OTP submit clicked' : 'Password submit clicked',
        },
      },
      'HOME',
    );
  };

  const sendOTPCaller = (data, otpCallback) => {
    let fd = new FormData();
    if (deviceWidth < 1024) {
      fd.append('dt', 'false');
    } else {
      fd.append('dt', 'true');
    }
    fd.append('username', data.username);
    clearUpdatePasswordMessages();
    setApiError('');
    fd.append('referrer', userUrl === '' ? docRef : newUrl);
    const successCallbackWrapper = resp => {
      sendOTPSuccessCallback(resp);
      otpCallback?.(resp?.success);
    };
    const errorCallbackWrapper = error => {
      errorCallback(error);
      otpCallback?.(false);
    };

    dispatch(login(fd, successCallbackWrapper, errorCallbackWrapper));
  };

  const resendOTP = () => {
    sendEvarData(
      {
        prop54: 'myPartner|login|OTP|resend',
      },
      true,
    );
    let fd = new FormData();
    fd.append('resend', 'mobile');
    fd.append('is_login', 'true');
    if (sendOTPResponse && sendOTPResponse.data && sendOTPResponse.data.token) {
      fd.append('token', sendOTPResponse.data.token);
    }
    dispatch(actions.resendOTP(fd, 'motp'));
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Resend OTP',
        },
      },
      'HOME',
    );
  };

  // Update Pwd Case (account_exists: false)
  const updatePassSuccessCallback = (succcessDataOrErrorData: any) => {
    setApiDataObject(succcessDataOrErrorData);
    // to show the updated message on login form for successfull pwd change after he comes back from update pwd page.
    setUpdatePwdSuccessMessage(
      succcessDataOrErrorData.message || 'Error! Please try after sometime.',
    );
    setApiError('');
  };
  const updatePassErrorCallback = data => {
    setUpdatePwdApiError(data.message);
  };
  const setPassword = data => {
    let fd = new FormData();
    fd.append('password', data.password);
    fd.append('confirm_password', data.confirm_pass);
    fd.append('token', apiDataObject.data?.token);
    fd.append('otp', data.mobile_otp);
    dispatch(actions.updatePass(fd, updatePassSuccessCallback, updatePassErrorCallback));
  };
  const resendUpdatePwdOtp = () => {
    setUpdatePwdApiError('');
    dispatch(
      actions.getPassTokenOrResendToken(
        apiDataObject.data?.token,
        getTokenSuccessCallback,
        getTokenErrorCallback,
        'resend',
      ),
    );
  };

  // Forgot Pwd case(Get token and update pwd, account_exists: true)
  const getTokenSuccessCallback = forgotPwdApiTokenData => {
    setForgotPasswordLoader(false);
    setApiDataObject(forgotPwdApiTokenData);
  };
  const getTokenErrorCallback = error => {
    setForgotPasswordLoader(false);
    setApiError(error.message || 'Error! Please try after sometime.');
  };
  const getToken = username => {
    setForgotPasswordLoader(true);
    const emailStringFlag = REGEX.EMAIL_REGEX.test(username) ? true : false;
    clearUpdatePasswordMessages();
    dispatch(
      actions.getPassTokenOrResendToken(
        username,
        getTokenSuccessCallback,
        getTokenErrorCallback,
        'forgotPwd',
        emailStringFlag,
      ),
    );
  };

  const clearUpdatePasswordMessages = () => {
    setUpdatePwdApiError('');
    setUpdatePwdSuccessMessage('');
  };

  //Email verify functions
  const emailVerificationSuccessCallback = data => {
    if (data?.is_verified) {
      window.open(responseRedirectUrl, '_self');
      return;
    }
    setVerificationScreen(popupToShow);
    setVerificationData(data?.popup_data);
    setLoginPageFlag(false);
    setModalUpdateDetailsData({
      componentData: data?.popup_data,
      modalData: data?.popup_data?.data?.[data?.popup_data?.data?.POPUP_TYPE],
    });
    return;
    setEmailActivationLinkInfoData(data);
    if (data.feature_enable) {
      if (data.is_verified) {
        window.open(responseRedirectUrl, '_self');
      } else {
        setLoginPageFlag(false);
      }
    } else {
      //window.open('https://www.makemytrip.com/flights/?action=smartbuy&open=browser', '_self');
      window.open(responseRedirectUrl, '_self');
    }
  };

  const emailVerificationErrorCallback = data => {
    window.open(responseRedirectUrl, '_self');
    sendEvarData(
      {
        prop22: 'error_fetching_the_email_verification_data',
      },
      true,
    );
  };
  //PAN VERIFICATION FUNCTIONS
  const panVerificationSuccessCallback = response => {
    setPanVerificationData(response);
    setLoginPageFlag(false);
  };

  const panVerificationErrorCallback = data => {
    window.open(responseRedirectUrl, '_self');
  };

  const getTdsSlabDataSuccessCallback = response => {
    setPanVerificationData(response);
    setLoginPageFlag(false);
  };

  const getTdsSlabDataErrorCallback = data => {
    window.open(responseRedirectUrl, '_self');
  };
  //GCC MOBILE VERIFICATION
  const gccMobileVerificationSuccessCallback = data => {
    setMobileVerificationData(data);

    setVerificationData(data?.popup_data);
    setModalUpdateDetailsData({
      componentData: data?.popup_data,
      modalData: data?.popup_data?.data[data?.popup_data?.data?.POPUP_TYPE],
    });
    if (data.feature_enable) {
      if (data.is_verified) {
        window.open(responseRedirectUrl, '_self');
      } else {
        setLoginPageFlag(false);
      }
    } else {
      //window.open('https://www.makemytrip.com/flights/?action=smartbuy&open=browser', '_self');
      window.open(responseRedirectUrl, '_self');
    }
  };

  const gccMobileVerificationErrorCallback = data => {
    sendEvarData(
      {
        prop22: 'error_fetching_the_email_verification_data',
      },
      true,
    );
    window.open(responseRedirectUrl, '_self');
  };

  const {message} = apiDataObject;
  let getLoginOrUpdatePwdForm = (
    <LoginNew
      userMobile={userMobile}
      submitDetails={submitDetails}
      resendOTP={resendOTP}
      sendOTP={sendOTPCaller}
      apiError={apiError}
      getToken={getToken}
      forgotPasswordLoader={forgotPasswordLoader}
      updatePwdSuccessMessage={updatePwdSuccessMessage}
      setLoader={isLoading}
      is2FARequired={is2FARequired}
    />
  );

  if (
    apiDataObject?.data?.hasOwnProperty('account_exists') &&
    !apiDataObject?.data?.account_exists
  ) {
    getLoginOrUpdatePwdForm = (
      <ForgetPassword
        apiError={updatePwdApiError}
        resendOTP={resendUpdatePwdOtp}
        setPassword={data => setPassword(data)}
        isLoading={isLoading}
        loginApiMessage={message}
        // mobileUser={userMobile}
        //  setLoader={setLoader}
      />
    );
  }
  return <>{getLoginOrUpdatePwdForm}</>;
};

export default LoginPop;
